import { render, staticRenderFns } from "./continuous.vue?vue&type=template&id=1236f091&scoped=true&"
import script from "./continuous.vue?vue&type=script&lang=js&"
export * from "./continuous.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1236f091",
  null
  
)

export default component.exports